import { render, staticRenderFns } from "./30.vue?vue&type=template&id=320980de&scoped=true&"
var script = {}
import style0 from "./30.vue?vue&type=style&index=0&id=320980de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320980de",
  null
  
)

export default component.exports